export default {
  path: '/pms',
  component: () => import('@/views/pms/index.vue'),
  children: [
    {
      path: '',
      name: 'PerformanceScoreSetup',
      component: () => import('@/views/pms/pages/PerformanceScoreSetup.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          // 'area_manager',
          // 'accounting_manager',
          'developer'
        ]
      }
    },
    {
      path: 'performance-score-setup/:id',
      name: 'PerformanceScoreSetupForm',
      component: () => import('@/views/pms/pages/PerformanceScoreSetupForm.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          // 'area_manager',
          // 'accounting_manager',
          'developer'
        ]
      }
    },
    {
      path: 'evaluation',
      name: 'PerformanceEvaluation',
      component: () => import('@/views/pms/pages/PerformanceEvaluation.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'area_manager',
          // 'accounting_manager',
          'developer'
        ]
      }
    },
    {
      path: 'evaluation/:id',
      name: 'PerformanceEvaluationDetail',
      component: () => import('@/views/pms/pages/PerformanceEvaluationDetail.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'area_manager',
          // 'accounting_manager',
          'developer'
        ]
      }
    },
    {
      path: 'review',
      name: 'PerformanceReview',
      component: () => import('@/views/pms/pages/PerformanceReview.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'area_manager',
          'accounting_manager',
          'developer',
          'vm'
        ]
      }
    },
    {
      path: 'performance-report',
      name: 'PerformanceReport',
      component: () => import('@/views/pms/pages/PerformanceReport.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'area_manager',
          'accounting_manager',
          'developer'
        ]
      }
    },
    {
      path: 'employees-list',
      name: 'EmployeesList',
      component: () => import('@/views/pms/pages/EmployeesList.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'area_manager',
          'accounting_manager',
          'office_admin',
          'developer',
          'support'
        ]
      }
    },
    {
      path: 'employee-detail/:userId',
      name: 'EmployeeDetail',
      component: () => import('@/views/pms/pages/EmployeeDetail.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'area_manager',
          'accounting_manager',
          'office_admin',
          'developer',
          'support'
        ]
      }
    },
    {
      path: 'broadcast-message',
      name: 'BroadcastMessage',
      component: () => import('@/views/pms/pages/BroadcastMessage.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'area_manager',
          'accounting_manager',
          'developer',
          'vm'
        ]
      }
    },
    {
      path: 'daily-briefs',
      name: 'DailyBriefs',
      component: () => import('@/views/pms/pages/DailyBriefs.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'accounting_manager',
          'area_manager',
          'developer',
          'vm'
        ]
      }
    },
    {
      path: 'customer-questionnaires',
      name: 'CustomerQuestionnaires',
      component: () => import('@/views/pms/pages/CustomerQuestionnaires.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          // 'accounting_manager',
          'developer'
        ]
      }
    },
    {
      path: 'settings',
      name: 'PerformanceReportSettings',
      component: () => import('@/views/pms/pages/Settings.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'accounting_manager',
          'developer',
          'vm'
        ]
      }
    }
  ]
}
